import type { RootState } from "../app/store";

export const selectSingleScrollHomeScreen = (state: RootState) =>
  !!(
    state.config.restaurantConfig?.singleScrollHomeScreen ??
    state.config.restaurantInfo?.config?.singleScrollHomeScreen
  );
